import React from 'react';

function UsersIcon02({ fill, ...restProps }) {
  return (
    <svg
      width='24'
      height='24'
      fill={fill ?? ''}
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M8.86 2.047a5.486 5.486 0 0 0-3.281 1.612c-2.096 2.112-2.099 5.542-.006 7.674 1.597 1.627 3.928 2.103 6.051 1.237 1.275-.521 2.425-1.671 2.946-2.946.746-1.827.503-3.826-.655-5.387a5.495 5.495 0 0 0-5.055-2.19m6.74.516a.968.968 0 0 0-.54 1.211c.085.271.248.443.635.671.405.238.651.438.918.746.587.676.867 1.423.867 2.309a3.477 3.477 0 0 1-1.811 3.074c-.348.194-.525.384-.609.652a.978.978 0 0 0 .273 1.043c.335.294.778.327 1.229.093a5.55 5.55 0 0 0 2.654-3.122 5.082 5.082 0 0 0 .272-1.74c0-.939-.198-1.754-.62-2.552-.519-.982-1.408-1.866-2.326-2.313-.377-.184-.649-.205-.942-.072m-5.195 1.552c.97.251 1.827.979 2.273 1.931.228.486.3.835.3 1.454s-.072.968-.3 1.454a3.569 3.569 0 0 1-2.318 1.951c-.367.102-1.353.102-1.72 0a3.597 3.597 0 0 1-2.298-1.9c-.247-.492-.314-.814-.314-1.505 0-.483.016-.66.083-.905.356-1.309 1.504-2.344 2.831-2.553.355-.056 1.108-.018 1.463.073M8.68 15.043c-2.123.198-4.022 1.043-5.806 2.584-.78.675-1.705 1.724-1.817 2.063a.99.99 0 0 0 1.052 1.297c.32-.032.499-.159.909-.646 1.634-1.936 3.6-3.064 5.75-3.299 2.588-.282 5.2.912 7.214 3.299.41.487.589.614.909.646a.99.99 0 0 0 1.052-1.297c-.088-.266-.559-.836-1.28-1.55-2.285-2.262-5.124-3.364-7.983-3.097m9.093.753a1.01 1.01 0 0 0-.761 1.065c.043.418.228.638.759.905a10.146 10.146 0 0 1 3.222 2.587c.386.464.58.602.895.634a.988.988 0 0 0 1.1-.88c.034-.333-.058-.549-.428-.998-.917-1.11-1.959-2.016-3.107-2.7-.887-.528-1.348-.696-1.68-.613'
        fill-rule='evenodd'
        fill={fill ?? ''}
      />
    </svg>
  );
}

export default UsersIcon02;
